import { render, staticRenderFns } from "./Transferir.vue?vue&type=template&id=a84ba7b8&"
import script from "./Transferir.vue?vue&type=script&lang=js&"
export * from "./Transferir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports